import { createAPIModule } from 'utility/redux/apiModuleHelpers';
import { createSelector } from 'reselect';

const getStateSlice = (state) => state.api.network.dns.record.update;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_RECORD_UPDATE',
	method: 'POST',
	url: '/network/dns/record/update.json',
});

const recordId = createSelector(defaultSelectors.getStateSlice, (slice) =>
	slice.getIn(['data', 'id'], null),
);

const selectors = {
	recordId,
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
